import React from 'react';
import styled from 'styled-components';

interface HamburgerIconProps {
    isOpen: boolean;
    onClick: () => void;
}

export const HamburgerIcon: React.FC<HamburgerIconProps> = ({ isOpen, onClick }) => {
    return (
        <StyledHamburgerButton onClick={onClick} $isOpen={isOpen}>
            <StyledHamburgerLine $isOpen={isOpen} />
            <StyledHamburgerLine $isOpen={isOpen} />
            <StyledHamburgerLine $isOpen={isOpen} />
        </StyledHamburgerButton>
    );
};

const StyledHamburgerButton = styled.button<{ $isOpen: boolean }>`
  display: none;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;
  position: relative;

  @media (max-width: 768px) {
    display: flex;
  }

  &:focus {
    outline: none;
  }
`;

const StyledHamburgerLine = styled.span<{ $isOpen: boolean }>`
  width: 2rem;
  height: 0.25rem;
  background: ${({ $isOpen }) => ($isOpen ? '#0A3D91' : '#333')};
  border-radius: 10px;
  transition: all 0.3s linear;
  position: relative;
  transform-origin: 1px;

  &:first-child {
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(45deg)' : 'rotate(0)')};
  }

  &:nth-child(2) {
    opacity: ${({ $isOpen }) => ($isOpen ? '0' : '1')};
    transform: ${({ $isOpen }) => ($isOpen ? 'translateX(20px)' : 'translateX(0)')};
  }

  &:nth-child(3) {
    transform: ${({ $isOpen }) => ($isOpen ? 'rotate(-45deg)' : 'rotate(0)')};
  }
`;
